import * as React from "react";
import { ShimmerEffectTabChartReq } from "../../ReusableComponents";
import { DashboardDropDownFilter, DashboardDropDownFilterIds, DashboardDropDownFilterValues } from "../../Shared/AppConstants";
import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartTitle,
    ChartLegend
} from '@progress/kendo-react-charts';
import { IDropDownModel } from "../../Shared/Models/IDropDownModel";
import withValueField from "../../Shared/withValueField";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import DashboardIcons from "../DashboardIcons";
import { downloadExcel, successToastr } from "../../../HelperMethods";
import { EXCEL_DOWNLOAD_SUCCESS_MSG } from "../../Shared/AppMessages";
import dashboardService from "../Service/DataService";
import { toolTip } from "../GlobalActions";

const CustomDropDownList = withValueField(DropDownList);

export interface DataChartProps { }
export interface DataChartState {
    data?: any;
    firstLoad?: any;
    filter?: Array<IDropDownModel>;
    filterId?: string;
    filterValue?: string;
    series?: any;
    categories?: any;
}

export default class DataChartContainer extends React.Component<
    DataChartProps,
    DataChartState
> {
    series: any;
    categories: any;
    constructor(props) {
        super(props);
        this.state = {
            firstLoad: true,
            data: [],
            filter: DashboardDropDownFilter,
            filterId: DashboardDropDownFilterIds.YEARTODATE,
            filterValue: DashboardDropDownFilterValues.YEARTODATE
        };
    }

    componentDidMount() {
        this.getReqWfChart(this.state.filterValue);
    }

    getReqWfChart(filterValue) {
        this.setState({ firstLoad: true });
        dashboardService.getReqWfChart(filterValue).then((res : any) => {
            this.setState({
                data: res.data[0],
                series:  JSON.parse(res.data[0].series),
                categories:  JSON.parse(res.data[0].categories),
                firstLoad: false
            });
        });
    }

    getReqWfChartDate(filterValue) {
        dashboardService.getReqWfChartData(filterValue).then((res: any) => {
            if (res) {
                downloadExcel("Requisition Workflow.xlsx", res.data);
                successToastr(EXCEL_DOWNLOAD_SUCCESS_MSG);
            }
        });
    }

    handleFilterChange = (e) => {
        const id = e.value.id;
        const value = e.value.value;
        this.setState({ filterId: id, filterValue: value }, () => { this.getReqWfChart(value); });
    }

    render() {
        const { firstLoad, data, series, categories } = this.state;
        this.categories = categories;
        this.series = series;

        return (
            <div>
                <div className='card card-radius pt-4 px-4 mb-23 pb-0 requisition-Workflow-chart'>
                    <div className='d-flex align-items-center justify-content-between mb-3'>
                        <h2 className='heading2 text-left mb-0 text-green'>Requisition</h2>
                        <div className='d-flex'>
                            <CustomDropDownList
                                className={"kpi-input-control month-to-date"}
                                data={this.state.filter}
                                name="name"
                                textField="name"
                                valueField="id"
                                id="filter"
                                value={this.state.filterId}
                                onChange={(e) => this.handleFilterChange(e)}
                            />
                            {toolTip(
                            <button className='ml-3 btn-transp icon-center icon-squire' onClick={() => this.getReqWfChartDate(this.state.filterValue)} title="Export"> 
                                <img className='normal-icon' src={DashboardIcons.downloadIcon} /> 
                                <img className='hover-icon' src={DashboardIcons.downloadIconHover} /> 
                            </button>
                            )}
                        </div>
                    </div>
                    {!firstLoad && data && this.series.length == 0 ? <div className="font-weight-bold w-100 mx-auto text-center">No Records Found!</div> :
                        !firstLoad && data && this.series.length > 0 ? <div className="row">
                            <div className="col-12">
                                <Chart>
                                    <ChartTitle />
                                    <ChartLegend position="bottom" labels={{font: "500 14px Arial, open-sans"}}/>
                                    <ChartCategoryAxis>
                                        <ChartCategoryAxisItem
                                            categories={this.categories}
                                            // title={{ text: data.title }}
                                        />
                                    </ChartCategoryAxis>
                                    <ChartSeries>
                                        {this.series.map((item, idx) => (
                                            <ChartSeriesItem
                                                key={idx}
                                                type="line"
                                                tooltip={{
                                                    visible: true,
                                                }}
                                                data={item.data}
                                                name={item.name}
                                                color={item.color}
                                            />
                                        ))}
                                    </ChartSeries>
                                </Chart>
                            </div>
                        </div>
                        : ShimmerEffectTabChartReq()
                    }
                </div>
            </div>
        )
    }
}